const translations = {
  // Category
  "category.popular":         "Popular Categories",
  "category.baby":            "Baby & Toddler",
  "category.clothing":        "Accessories",
  "category.electronics":     "Electronics",
  "category.restaurants":     "Restaurants",
  "category.health":          "Health & Beauty",
  "category.shoes":           "Shoes",
  "category.home":            "Home & Garden",
  "category.vacation":        "Vacation",
}

export default translations;